
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import namespaces for each language
// English
import enAccount from './locales/en/account.json';
import enAdmin from './locales/en/admin.json';
import enApp from './locales/en/app.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enEvents from './locales/en/events.json';
import enFeatures from './locales/en/features.json';
import enGamification from './locales/en/gamification.json';
import enLanguage from './locales/en/language.json';
import enLoyalty from './locales/en/loyalty.json';
import enNavigation from './locales/en/navigation.json';
import enPoints from './locales/en/points.json';
import enPrivacy from './locales/en/privacy.json';
import enProfile from './locales/en/profile.json';
import enQuests from './locales/en/quests.json';
import enRewards from './locales/en/rewards.json';
import enSocial from './locales/en/social';
import enGdpr from './locales/en/gdpr.json';
import enProjects from './locales/en/projects.json';
import enFooter from './locales/en/footer.json';

// French
import frAccount from './locales/fr/account.json';
import frAdmin from './locales/fr/admin.json';
import frApp from './locales/fr/app.json';
import frAuth from './locales/fr/auth.json';
import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frEvents from './locales/fr/events.json';
import frFeatures from './locales/fr/features.json';
import frGamification from './locales/fr/gamification.json';
import frLanguage from './locales/fr/language.json';
import frLoyalty from './locales/fr/loyalty.json';
import frNavigation from './locales/fr/navigation.json';
import frPoints from './locales/fr/points.json';
import frPrivacy from './locales/fr/privacy.json';
import frProfile from './locales/fr/profile.json';
import frQuests from './locales/fr/quests.json';
import frRewards from './locales/fr/rewards.json';
import frSocial from './locales/fr/social';
import frGdpr from './locales/fr/gdpr.json';
import frProjects from './locales/fr/projects.json';
import frFooter from './locales/fr/footer.json';

// Spanish
import esAdmin from './locales/es/admin.json';
import esApp from './locales/es/app.json';
import esAuth from './locales/es/auth.json';
import esCommon from './locales/es/common.json';
import esDashboard from './locales/es/dashboard.json';
import esEvents from './locales/es/events.json';
import esFeatures from './locales/es/features.json';
import esGamification from './locales/es/gamification.json';
import esLanguage from './locales/es/language.json';
import esLoyalty from './locales/es/loyalty.json';
import esNavigation from './locales/es/navigation.json';
import esPoints from './locales/es/points.json';
import esProfile from './locales/es/profile.json';
import esQuests from './locales/es/quests.json';
import esRewards from './locales/es/rewards.json';
import esSocial from './locales/es/social';
import esAccount from './locales/es/account.json';
import esPrivacy from './locales/es/privacy.json';
import esGdpr from './locales/es/gdpr.json';
import esProjects from './locales/es/projects.json';
import esFooter from './locales/es/footer.json';

// Define all the namespaces used in the application
export const namespaces = [
  'app', 'auth', 'dashboard', 'rewards', 'profile', 'features', 
  'language', 'admin', 'points', 'common', 'loyalty', 'quests', 
  'events', 'social', 'gamification', 'privacy', 'account', 'navigation', 'gdpr', 'projects',
  'footer'
];

// Initialize i18next
const i18nInstance = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        app: enApp,
        auth: enAuth,
        dashboard: enDashboard,
        profile: enProfile,
        rewards: enRewards,
        features: enFeatures,
        language: enLanguage,
        admin: enAdmin,
        points: enPoints,
        common: enCommon,
        loyalty: enLoyalty,
        quests: enQuests,
        events: enEvents,
        social: enSocial,
        gamification: enGamification,
        privacy: enPrivacy,
        account: enAccount,
        navigation: enNavigation,
        gdpr: enGdpr,
        projects: enProjects,
        footer: enFooter
      },
      fr: {
        app: frApp,
        auth: frAuth,
        dashboard: frDashboard,
        profile: frProfile,
        rewards: frRewards,
        features: frFeatures,
        language: frLanguage,
        admin: frAdmin,
        points: frPoints,
        common: frCommon,
        loyalty: frLoyalty,
        quests: frQuests,
        events: frEvents,
        social: frSocial,
        gamification: frGamification,
        privacy: frPrivacy,
        account: frAccount,
        navigation: frNavigation,
        gdpr: frGdpr,
        projects: frProjects,
        footer: frFooter
      },
      es: {
        app: esApp,
        auth: esAuth,
        dashboard: esDashboard,
        profile: esProfile,
        rewards: esRewards,
        features: esFeatures,
        language: esLanguage,
        admin: esAdmin,
        points: esPoints,
        common: esCommon,
        loyalty: esLoyalty,
        quests: esQuests,
        events: esEvents,
        social: esSocial,
        gamification: esGamification,
        privacy: esPrivacy,
        account: esAccount,
        navigation: esNavigation,
        gdpr: esGdpr,
        projects: esProjects,
        footer: esFooter
      }
    },
    fallbackLng: 'fr', // French as the default fallback
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for React
    },
    ns: namespaces,
    defaultNS: 'app',
    keySeparator: '.', // Use dot notation for accessing nested keys
    nsSeparator: ':', // We use colons to separate namespaces
    fallbackNS: 'common',
    load: 'all',
  });

export default i18n;
